const actionsMap = {
    'create': 'Created',
    'upload': 'Uploaded',
    'update': 'Updated',
    'delete': 'Deleted',
    'access': 'Accessed',
}

export {
    actionsMap
}